<template>
  <v-container>
    <v-dialog
      v-model="dialog.loading.visible"
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text
          class="pt-5 white--text"
        >
          <p>{{ dialog.loading.content }}</p>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col
        cols="12"
        md="6"
        class="text-justify pr-md-7"
      >
        <div class="title">
          Contact Summary
        </div>
        <hr class="mt-3 mb-1">

        <v-list>
          <v-list-item dense>
            <v-list-item-icon>
              <v-icon>person</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              {{ $store.state.contact.givenName }} {{ $store.state.contact.surname }}
            </v-list-item-content>
          </v-list-item>
          <v-list-item dense>
            <v-list-item-icon>
              <v-icon>cake</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              {{ $store.state.contact.dob | moment("DD/MM/YYYY") }}
            </v-list-item-content>
          </v-list-item>
          <v-list-item dense>
            <v-list-item-icon>
              <v-icon>email</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              {{ $store.state.contact.emailAddress }}
            </v-list-item-content>
          </v-list-item>
          <v-list-item dense>
            <v-list-item-icon>
              <v-icon>local_phone</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              {{ $store.state.contact.phone }}
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <hr class="mt-1 mb-3">

      </v-col>
      <v-col
        cols="12"
        md="6"
        class="text-justify pl-md-7"
      >
        <div class="title">
          Course Summary
        </div>
        <hr class="mt-3 mb-1">

        <v-list>
          <v-list-item dense>
            <v-list-item-icon>
              <v-icon>school</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              {{ $store.state.course.name }}
            </v-list-item-content>
          </v-list-item>
          <v-list-item dense>
            <v-list-item-icon>
              <v-icon>date_range</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              {{ $store.state.course.startDate | moment("dddd, DD MMM YYYY") }}
            </v-list-item-content>
          </v-list-item>
          <v-list-item dense>
            <v-list-item-icon>
              <v-icon>access_time</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              {{ $store.state.course.startDate | moment("hh:mmA") }}
              -
              {{ $store.state.course.endDate | moment("hh:mmA") }}
            </v-list-item-content>
          </v-list-item>
          <v-list-item dense>
            <v-list-item-icon>
              <v-icon>place</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              {{ $store.state.course.location }}
            </v-list-item-content>
          </v-list-item>

        </v-list>

        <hr class="mt-1 mb-3">

        <v-row>
          <v-col
            cols="8"
          >
            <v-text-field
              outlined
              label="Promo Code"
              prepend-inner-icon="mdi-ticket-percent"
              dense
              hide-details="auto"
              v-model="coupon"
              :disabled="disableCoupon"
            ></v-text-field>
          </v-col>
          <v-col
            cols="4"
          >
            <v-btn
              outlined
              block
              color="primary"
              height="40"
              :disabled="coupon.length == 0 || disableCoupon"
              @click="checkCoupon"
            >
              Apply
            </v-btn>
          </v-col>
        </v-row>
        

        <v-row>
          <v-col
            cols="6"
            class="subheading"
          >
            <b>Total:</b>
          </v-col>
          <v-col
            cols="6"
            class="text-sm-right"
          >
            <span
              v-if="discountedPrice != null"
              class="headline"
            >
               $ {{ $store.state.course.discountedPrice.toFixed(2) }}
            </span>

            <span 
              :class="{ 
                'text-decoration-line-through red--text' : discountedPrice != null,
                'headline': discountedPrice == null
               }"
            >
              $ {{ $store.state.course.cost.toFixed(2) }}
            </span>
            <span class="subheading">AUD</span>
          </v-col>
        </v-row>

        
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import axios from 'axios';
import axcelerate from './axcelerate.js';

export default {
  props: ['clickedNext', 'currentStep'],

  data() {
    return {
      disableCoupon: false,
      coupon: '',
      discountedPrice: null,
      dialog: {
        loading: {
          visible: false,
          content: '',
        },
      }
    }
  },


  computed: {
   
  },

  methods: {
    canContinue( ) {
      this.$emit('can-continue', {value: true});
    },
    checkCoupon( ) {
      this.dialog.loading.visible = true;
      this.dialog.loading.content = "Applying promo code, please wait ...";
      
      axios.post( axcelerate.checkCoupon( ), {
        'email': this.$store.state.contact.emailAddress,
        'coupon': this.coupon,
        'courseID': this.$store.state.course.instance,
        'price': this.$store.state.course.cost
      } )
      .then(response => {
        this.dialog.loading.visible = false;
        var discount = response.data;
        if( discount != null && discount.TOTALSAVING != 0 ) {
          console.log('Hey hey people');
          console.log( discount );
          this.$store.dispatch( 'setDiscountedPrice', {
            'price': discount.REVISEDPRICE,
            'id': discount.DISCOUNTSAPPLIED[0].DISCOUNTID
          } );
          this.discountedPrice = discount.REVISEDPRICE;
          this.$store.dispatch( 'setCoupon', this.coupon );
          this.disableCoupon = true;
        }
      });
    }
  },

  mounted() {
    this.$root.$on('canContinue', () => {
      this.canContinue();
    })
  },

  activated() {
    this.$emit('can-continue', {value: true});
  }

}
</script>
